// ** Third Party Components
import { Icon } from "components/icons";
import styled, { css, keyframes } from "styled-components";

// #####################################################

const rotate = keyframes`
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
`;

const StyledSvgIconContainer = styled.div`
	display: flex;
	color: ${({ $isDarkMode }) => ($isDarkMode ? "#a9a9a9" : "#8a8a8a")};

	${({ customMargin }) =>
		customMargin &&
		css`
			margin: ${customMargin};
		`}

	svg {
		display: inline-block;
		vertical-align: middle;
		fill: ${({ $isDarkMode }) => ($isDarkMode ? "#a9a9a9" : " #8a8a8a")};
		animation: ${rotate} 2s linear infinite;
		animation-delay: 0.1s; /* Opóźnienie 0.5 sekundy */

		${({ centerOnlyIcon }) =>
			centerOnlyIcon &&
			css`
				margin-left: 50%;
			`}
	}
`;

// #####################################################

export const LoaderOAuth = ({
	size = 30,
	customMargin,
	centerOnlyIcon,
	isDarkMode,
}) => {
	// Wszystkie SVG w tym komponencie są od nas z plików i nie miały zapisu o licencji.
	return (
		<StyledSvgIconContainer
			customMargin={customMargin}
			centerOnlyIcon={centerOnlyIcon}
			$isDarkMode={isDarkMode}
		>
			<Icon name="spinner" height={`${size}px`} />
		</StyledSvgIconContainer>
	);
};

// #####################################################
